module.exports = __webpack_public_path__ + "img/arrow_dropdown.098ba7e4.svg";